/** Standard snackbar durations for consistent UX */
export const SNACKBAR_DURATION = {
  success: 3000,
  warning: 5000,
  error: 6000,
} as const;

export const SNACKBAR_ERROR_CONFIG = {
  duration: SNACKBAR_DURATION.error,
  tone: 'error',
} as const;
